import { createNotesContextProvider } from 'src/SharedCommonContext/GenericNotesContextFactory';

export const {
  NotesProvider: ContactNotesProvider,
  useNotesDataFromContext: useContactNotesDataFromContext,
  useNotesActionsFromContext: useContactNotesActionsFromContext,
} = createNotesContextProvider({
  itemType: 'Contact',
  displayName: 'contact',
});
